export default "__VITE_ASSET__CDISBnwO__"